import React, { createContext, useContext, useState } from 'react';

interface AppContextState {
  currentApp: string;
  isNavMenuClose: boolean;
}

interface AppContextValue {
  state: AppContextState;
  appContextAction: {
    app: {
      default: () => void;
      open: (appName: string) => void;
    };
    navMenu: {
      collapse: () => void;
      expand: () => void;
    };
  };
}

const AppContext = createContext<AppContextValue | undefined>(undefined);

export function AppContextProvider({ children }: { children: React.ReactNode }) {
  const [state, setState] = useState<AppContextState>({
    currentApp: 'default',
    isNavMenuClose: false,
  });

  const appContextAction = {
    app: {
      default: () => {
        setState(prev => ({ ...prev, currentApp: 'default' }));
      },
      open: (appName: string) => {
        setState(prev => ({ ...prev, currentApp: appName }));
      },
    },
    navMenu: {
      collapse: () => {
        setState(prev => ({ ...prev, isNavMenuClose: true }));
      },
      expand: () => {
        setState(prev => ({ ...prev, isNavMenuClose: false }));
      },
    },
  };

  return (
    <AppContext.Provider value={{ state, appContextAction }}>
      {children}
    </AppContext.Provider>
  );
}

export function useAppContext() {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useAppContext must be used within an AppContextProvider');
  }
  return context;
}